import React from 'react';

const PrivateGigsTagNodification = ({ capitalizeFirstLetter, userProfile }) => {
  return (
      <div className="private-mkt-nodifiction">
          {userProfile?.Profiles?.PictureUrl ? <img
              src={`${process.env.REACT_APP_S3_URL}${userProfile?.Profiles?.PictureUrl?.charAt(0) !== "/" ? "/" : ""
                  }${userProfile?.Profiles?.PictureUrl}`}
              className="noti-img"
          /> : userProfile?.Profiles?.FirstName && capitalizeFirstLetter(userProfile?.Profiles?.FirstName?.charAt(0))}
      </div>
  );
};

export default PrivateGigsTagNodification;